/**
 * @file
 * Open positions listing page positions sorting.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.open_positions = {
    attach: function (context, settings) {

      const openPositionsListing = "#open-positions-listing";
      const openPositionsSort = ".all-positions-listing .listing-sort";

      if ($(openPositionsListing).length) {

        // Init select2
        $(openPositionsSort).select2({
          minimumResultsForSearch: -1
        });

        $(openPositionsSort).on('change', function (e) {

          let divList = $("#open-positions-listing .position");

          if (e.target.value === "posted") {
            divList.sort(function (a, b) {
              return $(b).data("posted") - $(a).data("posted")
            });
          } else {
            divList.sort(function (a, b) {
              return $(a).data("closes") - $(b).data("closes")
            });
          }

          $("#open-positions-listing").html(divList);

        });

      }

    }
  };

})(jQuery, Drupal);
